import { NotFound as NotFoundComponent } from '@project44/shared-components';

export function NotFound() {
  return <NotFoundComponent />;
}
